type FormChecks = { state: boolean[][]; default: boolean[][] }

let rules = {}
let messages = {}

const textInputs = ["text", "number", "tel", "email"]
const attrs = {
  form: "data-step-form",
  content: "data-step-form-content",
  input: "data-step-form-input",
  validate: "data-step-form-validate",
  field: "data-step-form-field",
  error: "data-step-form-error",
  message: "data-step-form-message",
  href: "data-step-form-href",
  reset: "data-step-form-reset",
  loading: "data-step-form-loading",
}

function validateTextInput(value: string, type: string, hasRequired: boolean) {
  let check = true
  let message = ""

  if (!hasRequired && !value.trim()) {
    return { check, message }
  }
  switch (type) {
    case "email":
      if (hasRequired && !value.trim()) {
        check = false
        message = messages.email.required
      } else if (value.length > rules.email.maxlength) {
        check = false
        message = messages.email.maxlength
      } else if (!new RegExp(rules.email.pattern).test(value)) {
        check = false
        message = messages.email.pattern
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        check = false
        message = messages.email.email
      }
      break

    case "tel":
      if (hasRequired && !value.trim()) {
        check = false
        message = messages.phoneNumber.required
      } else if (
        value.length < rules.phoneNumber.minlength ||
        value.length > rules.phoneNumber.maxlength
      ) {
        check = false
        message = messages.phoneNumber.minlength
      } else if (!new RegExp(rules.phoneNumber.pattern).test(value)) {
        check = false
        message = messages.phoneNumber.pattern
      }
      break

    case "number":
      if (isNaN(Number(value))) {
        check = false
        message = messages.number.pattern
      }
      break

    default:
      if (hasRequired && !value.trim()) {
        check = false
        message = messages.text.required
      }
      break
  }

  return { check, message }
}

function switchNav(
  checks: boolean[],
  target: HTMLInputElement | HTMLSelectElement
) {
  const contentEl = target.closest(`[${attrs.content}]`)
  if (!contentEl) return
  const fieldEls = [...contentEl.querySelectorAll(`[${attrs.field}]`)]
  if (!fieldEls.length) return

  const nextRequired = checks.indexOf(false)

  fieldEls.forEach((fieldEl, index) => {
    if (index === nextRequired) {
      fieldEl.setAttribute(attrs.field, "nav")
    } else {
      fieldEl.setAttribute(attrs.field, "")
    }
  })
}

function switchError(
  check: boolean,
  target: HTMLInputElement | HTMLSelectElement,
  message: string
) {
  const fieldEl = target.closest(`[${attrs.field}]`)
  if (!fieldEl) return
  const errorEl = fieldEl.querySelector(`[${attrs.error}]`)
  if (!errorEl) return

  if (check) {
    errorEl.classList.remove("is-active")
  } else {
    const messageEl = fieldEl.querySelector(`[${attrs.message}]`)
    messageEl && (messageEl.textContent = message)
    errorEl.classList.add("is-active")
  }
}

function addValidateEvent(
  formChecks: FormChecks,
  contentIndex: number,
  validateEl: Element,
  inputEl: Element,
  inputIndex: number
) {
  let checks = formChecks.state[contentIndex]

  const tagName = inputEl.tagName.toLowerCase()
  const type = inputEl.getAttribute("type") || ""
  const hasRequired = inputEl.hasAttribute("required")
  const firstRequired = checks.indexOf(false)

  if (inputIndex === firstRequired) {
    const fieldEl = inputEl.closest(`[${attrs.field}]`)
    if (fieldEl) {
      fieldEl.setAttribute(attrs.field, "nav")
    }
  }

  if (tagName === "input" && textInputs.includes(type)) {
    inputEl.addEventListener("blur", (e) => {
      const target = e.target as HTMLInputElement
      const value = target.value
      const { check, message } = validateTextInput(value, type, hasRequired)
      checks[inputIndex] = check
      const allCheck = checks.every((check) => check)
      validateEl && validateEl.setAttribute(attrs.validate, `${allCheck}`)
      switchNav(checks, target)
      switchError(check, target, message)
    })
    if (type === "tel") {
      inputEl.addEventListener("input", (e) => {
        const target = e.target as HTMLInputElement
        const value = target.value
        const { check } = validateTextInput(value, type, hasRequired)
        checks[inputIndex] = check
        const allCheck = checks.every((check) => check)
        validateEl && validateEl.setAttribute(attrs.validate, `${allCheck}`)
        switchNav(checks, target)
      })
    }
  }
  if (tagName === "input" && type === "checkbox") {
    inputEl.addEventListener("change", (e) => {
      const target = e.target as HTMLInputElement
      const value = target.checked
      const check = value ? true : hasRequired ? false : true
      const message = messages.checkbox.required
      checks[inputIndex] = check
      const allCheck = checks.every((check) => check)
      validateEl && validateEl.setAttribute(attrs.validate, `${allCheck}`)
      switchNav(checks, target)
      switchError(check, target, message)
    })
  }
  if (tagName === "select") {
    inputEl.addEventListener("change", (e) => {
      const target = e.target as HTMLSelectElement
      const value = target.value
      const check = value ? true : hasRequired ? false : true
      const message = messages.select.required
      checks[inputIndex] = check
      const allCheck = checks.every((check) => check)
      validateEl && validateEl.setAttribute(attrs.validate, `${allCheck}`)
      switchNav(checks, target)
      switchError(check, target, message)
    })
  }
}

function resetForm(formChecks: FormChecks, formEl: HTMLFormElement) {
  formChecks.state.forEach((stateChecks, index) => {
    stateChecks.forEach((_, i) => {
      stateChecks[i] = formChecks.default[index][i]
    })
  })
  formEl.reset()
  formEl.focus()

  const contentEls = [...formEl.querySelectorAll(`[${attrs.content}]`)]

  contentEls.forEach((contentEl, contentIndex) => {
    const checks = formChecks.state[contentIndex]

    const firstRequired = checks.indexOf(false)
    const fieldEls = [...contentEl.querySelectorAll(`[${attrs.field}]`)]

    fieldEls.forEach((fieldEl, index) => {
      if (index === firstRequired) {
        fieldEl.setAttribute(attrs.field, "nav")
      } else {
        fieldEl.setAttribute(attrs.field, "")
      }
    })
    const allCheck = checks.every((check) => check)
    const validateEl = contentEl.querySelector(`[${attrs.validate}]`)
    validateEl && validateEl.setAttribute(attrs.validate, `${allCheck}`)
  })
}

function addHrefEvent(
  formChecks: FormChecks,
  contentIndex: number,
  formEl: HTMLFormElement,
  inputEls: Element[],
  hrefEl: Element
) {
  hrefEl.addEventListener("click", (e) => {
    e.preventDefault()
    let checks = formChecks.state[contentIndex]

    const allCheck = checks.every((check) => check)
    const hasValidate = hrefEl.hasAttribute(attrs.validate)
    const hasReset = hrefEl.hasAttribute(attrs.reset)
    const loading = hrefEl.getAttribute(attrs.loading)
    const currentEl = formEl.querySelector(`[${attrs.content}].is-active`)
    const nextId = hrefEl.getAttribute(attrs.href)
    const nextEl = formEl.querySelector(`[${attrs.content}="${nextId}"]`)

    if (hasValidate) {
      checks.map((check, index) => {
        if (check) return
        const inputEl = inputEls[index]
        const tagName = inputEl.tagName.toLowerCase()
        const type = inputEl.getAttribute("type") || ""

        if (tagName === "input" && textInputs.includes(type)) {
          const target = inputEl as HTMLInputElement
          const value = target.value
          const { check, message } = validateTextInput(value, type, true)
          switchError(check, target, message)
        }
        if (tagName === "input" && type === "checkbox") {
          const target = inputEl as HTMLInputElement
          const value = target.checked
          const check = value ? true : false
          const message = messages.checkbox.required
          switchError(check, target, message)
        }
        if (tagName === "select") {
          const target = inputEl as HTMLSelectElement
          const value = target.value
          const check = value ? true : false
          const message = messages.select.required
          switchError(check, target, message)
        }
      })
      if (!allCheck) return
    }

    if (hasReset) {
      const isForm = formEl.tagName.toLowerCase() === "form"
      const form = isForm ? (formEl as HTMLFormElement) : undefined
      if (form) form.reset()
      resetForm(formChecks, formEl)
      formEl.focus()
    }

    if (loading) {
      const loadingTime = Number(loading) || 0
      const loadingEl = document.getElementById("loading")
      if (loadingEl) loadingEl.classList.add("is-active")

      setTimeout(() => {
        if (loadingEl) loadingEl.classList.remove("is-active")
        if (currentEl) currentEl.classList.remove("is-active")
        if (nextEl) nextEl.classList.add("is-active")
      }, loadingTime)
    } else {
      if (currentEl) currentEl.classList.remove("is-active")
      if (nextEl) nextEl.classList.add("is-active")
    }
  })
}

export function initStepForm() {
  const formEls = [
    ...document.querySelectorAll(`[${attrs.form}]`),
  ] as HTMLFormElement[]
  if (!formEls.length) return

  for (const formEl of formEls) {
    const contentEls = [...formEl.querySelectorAll(`[${attrs.content}]`)]
    if (!contentEls.length) continue

    let formChecks: FormChecks = { state: [], default: [] }

    contentEls.forEach((contentEl) => {
      const inputEls = [...contentEl.querySelectorAll(`[${attrs.input}]`)]
      const checks = inputEls.map((inputEl) => {
        const tagName = inputEl.tagName.toLowerCase()
        const type = inputEl.getAttribute("type") || ""

        if (!inputEl.hasAttribute("required")) {
          return true
        }
        if (tagName === "input" && textInputs.includes(type)) {
          const target = inputEl as HTMLInputElement
          const value = target.value
          const { check } = validateTextInput(value, type, true)
          return check
        }
        if (tagName === "input" && type === "checkbox") {
          const target = inputEl as HTMLInputElement
          const value = target.checked
          const check = value ? true : false
          return check
        }
        if (tagName === "select") {
          const target = inputEl as HTMLSelectElement
          const value = target.value
          const check = value ? true : false
          return check
        }
        return false
      })
      formChecks.state.push([...checks])
      formChecks.default.push([...checks])
    })
    contentEls.forEach((contentEl, contentIndex) => {
      const inputEls = [...contentEl.querySelectorAll(`[${attrs.input}]`)]
      const hrefEls = [...contentEl.querySelectorAll(`[${attrs.href}]`)]
      const validateEl = contentEl.querySelector(`[${attrs.validate}]`)

      inputEls.forEach((inputEl, inputIndex) => {
        addValidateEvent(
          formChecks,
          contentIndex,
          validateEl,
          inputEl,
          inputIndex
        )
      })
      hrefEls.forEach((hrefEl) => {
        addHrefEvent(formChecks, contentIndex, formEl, inputEls, hrefEl)
      })
    })
  }
}

// データの設定が完了してから初期化を実行
document.addEventListener('souoba-shindan-form-data-initialized', () => {
  if (!window.Nifty?.Utils?.ValidationRule?.rules || !window.Nifty?.Utils?.ValidationRule?.messages) {
    return
  }

  // バリデーションは既存のルールを適用
  rules = window.Nifty?.Utils?.ValidationRule?.rules
  messages = Object.assign(window.Nifty?.Utils?.ValidationRule?.messages, {
    checkbox: {
      required: "※チェックを入れてください",
    },
    select: {
      required: "※いずれかを選択してください",
    }
  })

  initStepForm()
})
